<template>
  <div class="logoBody">
    <img src="../assets/White Small Logo.png" alt="Please wait">
  </div>
</template>

<script>
  import firebase from 'firebase';

  export default {
    mounted(){

     // Do something
      setTimeout(() => {
        if(!firebase.auth().currentUser){
          this.$router.push({name: 'firstpage'})
        }
      },2000);

    }
  }
</script>

<style scoped>
  .logoBody {
    height: 100%;
    width: 100%;
    background-color: #0055D4;
  }

  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 46px;
    margin: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/LogoPage.vue